import { create } from 'zustand';

interface UseLoggedOnBehalfStore {
  data: boolean;
  setLoggedOnBehalf: (status: boolean) => void;
}

export const useLoggedOnBehalfStore = create<UseLoggedOnBehalfStore>((set) => ({
  data: false,

  setLoggedOnBehalf: (status) => set(() => ({ data: status })),
}));
